import React from "react";

export default function Footer() {
  return (
    <>
      <div className="flex items-center justify-center w-full text-gray-800 ">
        © 2023 Chapchrono - Tous droits réservés
      </div>
    </>
  );
}
